import { render, staticRenderFns } from "./Europe40under40AwardFrame.vue?vue&type=template&id=5d2a1dfe"
import script from "./Europe40under40AwardFrame.vue?vue&type=script&lang=js"
export * from "./Europe40under40AwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2a1dfe')) {
      api.createRecord('5d2a1dfe', component.options)
    } else {
      api.reload('5d2a1dfe', component.options)
    }
    module.hot.accept("./Europe40under40AwardFrame.vue?vue&type=template&id=5d2a1dfe", function () {
      api.rerender('5d2a1dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/europe40under40-design-award/components/Europe40under40AwardFrame.vue"
export default component.exports